<div style="background-color: black; height: 24px; margin: auto; ">
  <p align="center" style=" font-size: 1.25vw; color: white;">
    Application Initialization Error
  </p>
</div>
<p align="center" style="padding: 6px 80px 0px 80px;">
  Sorry there was an error during the application initialization process.
</p>
